//@flow
import React from 'react';
import {makeStyles} from '@material-ui/core';
import {colors} from '../../assets/styles/colors';
import type {TemplateButtonsComponent as ButtonsType} from '../../entities/multichat/whatsapp-api';

type Props = {
  component: ButtonsType,
};

const useStyles = makeStyles(() => ({
  buttons: {
    position: 'relative',
    display: 'flex',
    gap: '4px',
    width: '100%',
    flexWrap: 'wrap',
    maxWidth: '250px',
  },
  button: {
    color: colors.info,
    border: 'none',
    flexGrow: 1,
    borderRadius: '8px',
    padding: '8px 16px',
    cursor: 'pointer',
    fontSize: '14px',
    boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)',
    backgroundColor: '#f9f9f9',
  },
}));

export default function TemplateButtonsComponent({component}: Props) {
  const classes = useStyles();

  if (!component.buttons || component.buttons.length === 0) return null;

  return (
    <div className={classes.buttons}>
      {component.buttons.map((button, idx) => (
        <button key={idx} className={classes.button} type="button">
          {button.text}
        </button>
      ))}
    </div>
  );
}
